import { useLayoutEffect } from "react"
import { createBrowserRouter, Navigate, Outlet, useLocation } from "react-router-dom"
import MarketingHome from "./pages/marketing/Home"
import HowItWorksPage from "./pages/marketing/HowItWorks"
import FairyHome from "./pages/marketing/Fairy"
import LoginPage from "./pages/auth/Login"
import Pricing from "./pages/marketing/Pricing"
import OnboardFlow from "./pages/onboard/OnboardFlow"
import NumberAllocStep from "./pages/onboard/NumberAlloc"
import ContactStep from "./pages/onboard/Contact"
import { AppShell } from "./AppShell"
import DashboardPage from "./pages/app/Dashboard"
import SessionsPage from "./pages/app/Sessions"
import DemonsPage from "./pages/app/Demons"
import BillingPage from "./pages/app/Billing"
import SettingsPage from "./pages/app/Settings"
import DeadLettersPage from "./pages/admin/DeadLetters"
import WebhooksPage from "./pages/admin/Webhooks"
import AdminTenantsPage from "./pages/admin/Tenants"
import PublicInvoiceView from "./pages/public/InvoiceView"
import InvoiceSuccess from "./pages/public/Success"
import InvoiceFailure from "./pages/public/Failure"
import HelpPage from "./pages/help/Help"
import TermsPage from "./pages/legal/Terms"
import PrivacyPage from "./pages/legal/Privacy"
import SMSTermsPage from "./pages/legal/SMSTerms"
import SMSCompliancePage from "./pages/legal/SMSCompliance"
import NotFoundPage from "./pages/system/NotFound"
import ErrorPage from "./pages/system/Error"
import MaintenancePage from "./pages/system/Maintenance"

function RootLayout() {
  const { pathname } = useLocation()
  useLayoutEffect(() => {
    // Own scroll position: land at the top on every navigation and refresh
    // instead of inheriting the previous page's scroll offset.
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual"
    }
    window.scrollTo(0, 0)
  }, [pathname])
  return <Outlet />
}

const routes = [
  { path: "/", element: <MarketingHome /> },
  { path: "/demo", element: <Navigate to="/how-it-works" replace /> },
  { path: "/how-it-works", element: <HowItWorksPage /> },
  { path: "/fairy", element: <FairyHome /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/pricing", element: <Pricing /> },
  {
    path: "/onboard",
    element: <OnboardFlow />,
    children: [
      { index: true, element: <ContactStep /> },
      { path: "contact", element: <ContactStep /> },
      { path: "number", element: <NumberAllocStep /> },
      { path: "*", element: <Navigate to="/onboard/contact" replace /> },
    ],
  },
  {
    path: "/app",
    element: <AppShell />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: "dashboard", element: <DashboardPage /> },
      { path: "invoices", element: <SessionsPage /> },
      { path: "sessions", element: <Navigate to="/app/invoices" replace /> },
      { path: "customers", element: <DemonsPage /> },
      { path: "demons", element: <Navigate to="/app/customers" replace /> },
      { path: "billing", element: <BillingPage /> },
      { path: "settings", element: <SettingsPage /> },
      {
        path: "admin",
        children: [
          { index: true, element: <Navigate to="dead-letters" replace /> },
          { path: "dead-letters", element: <DeadLettersPage /> },
          { path: "webhooks", element: <WebhooksPage /> },
          { path: "tenants", element: <AdminTenantsPage /> },
        ],
      },
    ],
  },
  { path: "/public/invoices/:token", element: <PublicInvoiceView /> },
  { path: "/public/success", element: <InvoiceSuccess /> },
  { path: "/public/failure", element: <InvoiceFailure /> },
  { path: "/help", element: <HelpPage /> },
  { path: "/legal/terms", element: <TermsPage /> },
  { path: "/legal/privacy", element: <PrivacyPage /> },
  { path: "/legal/sms-terms", element: <SMSTermsPage /> },
  { path: "/legal/sms-compliance", element: <SMSCompliancePage /> },
  { path: "/system/error", element: <ErrorPage /> },
  { path: "/system/maintenance", element: <MaintenancePage /> },
  { path: "*", element: <NotFoundPage /> },
]

const router = createBrowserRouter([{ element: <RootLayout />, children: routes }])

export default router
